<template>
  <div
    class="grey lighten-4"
    :class="{
      'position-sticky page-toolbar--sticky': sticky,
      'page-toolbar--loading': loading,
    }"
    style="
      border-bottom: 1px solid #e0e0e0;
      position: relative;
      transition: all 0.2s ease;
    "
  >
    <v-container fluid class="px-3 px-sm-4 px-md-6 pt-1 pb-3">
      <v-row align="end">
        <!-- Filters with horizontal scroll -->
        <v-col v-if="$slots.filters || searchable" cols="12" class="flex-grow-1">
          <div
            style="position: relative; width: 100%; display: flex; align-items: center"
          >
            <!-- Left scroll button -->
            <v-btn
              v-if="showLeftScroll && hasScrollableContent"
              icon
              small
              color="primary"
              dark
              elevation="2"
              style="position: absolute; left: 4px; top: 32px; z-index: 2"
              @click="scrollLeft"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>

            <!-- Filters container -->
            <div
              ref="filtersContainer"
              @scroll="checkScroll"
              class="filters-scroll-container"
              :style="{
                width: hasScrollableContent ? 'calc(100% - 96px)' : '100%',
                marginLeft: hasScrollableContent ? '48px' : '0',
                marginRight: hasScrollableContent ? '48px' : '0',
                overflowX: 'auto',
                overflowY: 'hidden',
                scrollBehavior: 'smooth',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
              }"
            >
              <v-row no-gutters align="center" class="flex-nowrap" style="gap: 12px">
                <slot name="filters" />
                <text-field
                  v-if="searchable"
                  v-model="model"
                  @input="$emit('update:search', $event)"
                  kind="search"
                  color="white"
                  hide-details
                  :label="$t('search')"
                  :disabled="loading"
                  style="min-width: 200px; flex-shrink: 0"
                />
              </v-row>
            </div>

            <!-- Right scroll button -->
            <v-btn
              v-if="showRightScroll && hasScrollableContent"
              icon
              small
              color="primary"
              dark
              elevation="2"
              style="position: absolute; right: 4px; top: 32px; z-index: 2"
              @click="scrollRight"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <!-- Loading overlay -->
    <div v-if="loading" class="position-absolute" style="bottom: -2px; left: 0; right: 0">
      <v-progress-linear indeterminate color="primary" height="2" />
    </div>
  </div>
</template>

<script>
import hasModel from "@/mixins/hasModel";
export default {
  mixins: [hasModel],
  name: "PageToolbar",
  data() {
    return {
      showLeftScroll: false,
      showRightScroll: false,
      hasScrollableContent: false,
    };
  },
  props: {
    search: {
      type: String,
      default: "",
    },
    searchable: {
      type: Boolean,
      default: true,
    },
    searchPlaceholder: {
      type: String,
      default: "",
    },
    sticky: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.checkScroll();
      window.addEventListener("resize", this.checkScroll);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScroll);
  },
  updated() {
    this.$nextTick(() => {
      this.checkScroll();
    });
  },
  methods: {
    checkScroll() {
      this.$nextTick(() => {
        const container = this.$refs.filtersContainer;
        if (container) {
          this.hasScrollableContent = container.scrollWidth > container.clientWidth;
          this.showLeftScroll = container.scrollLeft > 0;
          this.showRightScroll =
            container.scrollLeft < container.scrollWidth - container.clientWidth - 1;
        }
      });
    },
    scrollLeft() {
      const container = this.$refs.filtersContainer;
      if (container) {
        container.scrollBy({ left: -300, behavior: "smooth" });
      }
    },
    scrollRight() {
      const container = this.$refs.filtersContainer;
      if (container) {
        container.scrollBy({ left: 300, behavior: "smooth" });
      }
    },
  },
};
</script>

<style scoped>
.page-toolbar--sticky {
  position: sticky !important;
  top: 160px;
  z-index: 8;
}

.page-toolbar--loading {
  opacity: 0.7;
  pointer-events: none;
}

.filters-scroll-container::-webkit-scrollbar {
  display: none;
}
</style>
